import { render, staticRenderFns } from "./openidBind.vue?vue&type=template&id=997237f4&scoped=true&"
import script from "./openidBind.vue?vue&type=script&lang=js&"
export * from "./openidBind.vue?vue&type=script&lang=js&"
import style0 from "./openidBind.vue?vue&type=style&index=0&id=997237f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997237f4",
  null
  
)

component.options.__file = "openidBind.vue"
export default component.exports